// src/utils/dbOperationsComb/index.js
//
// The single entry point for database work. Everything callable is exported
// from here, so callers use one import:
//
//   import DBOperationsComb from "src/utils/dbOperationsComb";
//
// - ./dbOperations.js — generic table actions over local RxDB + online
//   Supabase (insert / update / fetch / get / delete / …, useSupabaseRPC).
// - ./dbFunctions.js — one named function per Postgres function (RPC).

import DBOperations from "./dbOperations";
import DbFunctions from "./dbFunctions";

export default {
  ...DBOperations,
  ...DbFunctions
};
